import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { Family } from "../../interfaces/DTO/crm/family";
import { Contact } from "../../interfaces/DTO/crm/contact";
import CustomAvatar from "../../shared/UIParts/CustomAvatar";
import EditableTextField from "../../shared/UIParts/EditableTextField";
import { useUpdateFamily } from "../../hooks/crm/useFamilies";
import { formatAge } from "../../utils/namesFormater";

interface FamilyInfoProps {
  family: Family;
  familyMemberContacts: Contact[];
}

export const FamilyInfo: React.FC<FamilyInfoProps> = ({
  family,
  familyMemberContacts,
}) => {
  const [editedFamilyName, setEditedFamilyName] = useState(family.name);
  const updateFamilyMutation = useUpdateFamily();

  const handleSaveClick = async (newName: string) => {
    try {
      const updatedFamily: Family = {
        ...family,
        name: newName,
      };

      await updateFamilyMutation.mutateAsync({
        id: updatedFamily.id,
        data: updatedFamily,
      });
    } catch (error) {
      console.error("Error updating family:", error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        p: 2,
        borderRadius: "8px",
        backgroundColor: "background.paper",
        boxShadow: 1,
      }}
    >
      <CustomAvatar
        item={family}
        isUser={false}
        userColor="#1976d2"
        familyColor="#4caf50"
        sx={{ width: 200, height: 200 }}
      />

      <EditableTextField
        value={editedFamilyName}
        onSave={(newValue) => {
          setEditedFamilyName(newValue);
          handleSaveClick(newValue);
        }}
        isLoading={updateFamilyMutation.status === "pending"}
      />

      <Typography variant="body1">
        חברים במשפחה: {familyMemberContacts.length}
      </Typography>

      {updateFamilyMutation.isError && (
        <Typography color="error">
          שגיאה בעדכון המשפחה: {updateFamilyMutation.error?.message}
        </Typography>
      )}

      <Box
        sx={{
          width: "100%",
          mt: 3,
          p: 2,
          borderRadius: "8px",
          backgroundColor: "background.default",
          boxShadow: 1,
        }}
      >
        <Typography variant="h6">פרטי חברי המשפחה</Typography>
        {familyMemberContacts.map((member) => (
          <Box
            key={member.id}
            sx={{
              mt: 2,
              p: 2,
              border: "1px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "white",
            }}
          >
            <Typography variant="body1">
              <strong>שם:</strong> {`${member.first_name} ${member.last_name}`}
            </Typography>
            <Typography variant="body1">
              <strong>גיל:</strong>{" "}
              {member?.date_of_birth ? formatAge(member.date_of_birth) : "לא ידוע"}
            </Typography>
            <Typography variant="body1">
              <strong>מספר תעודת זהות:</strong> {member?.israeli_id || "לא זמין"}
            </Typography>
            <Typography variant="body1">
              <strong>מספר סלולרי:</strong> {member?.phone || "לא זמין"}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
